import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModule } from 'ngx-bootstrap/alert';

import { SystemAdminDashboardRoutingModule } from './system-admin-dashboard-routing.module';
import { SystemAdminDashboardComponent } from './system-admin-dashboard/system-admin-dashboard.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from 'shared/shared.module';


@NgModule({ declarations: [
        SystemAdminDashboardComponent
    ], imports: [CommonModule,
        SystemAdminDashboardRoutingModule,
        AlertModule,
        SharedModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SystemAdminDashboardModule { }
